import { render, staticRenderFns } from "./vFormVERTICAL_SPACE.vue?vue&type=template&id=84d1dde8&scoped=true&"
import script from "./vFormVERTICAL_SPACE.vue?vue&type=script&lang=js&"
export * from "./vFormVERTICAL_SPACE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1dde8",
  null
  
)

export default component.exports